import React, { useEffect, useState } from "react";
import Style from './WorkingHours.module.css';
import Button from '../../../components/controls/button/Button'
import WorkingHoursItem from "./WorkingHoursItem";

const WorkingHours = (props) => {
    const { updateWorkingHours, loading } = props;    
    const [workingHours, setWorkingHours] = useState([]);
    const user = JSON.parse(localStorage.getItem('user'));
    const initialWorkingHours = user.workingHours;

    const handleSave = () => {
        updateWorkingHours({workingHours});
    }  

    const handleItemChange = (index, newItem) => {
        setWorkingHours(prevHours => {
            const updatedHours = [...prevHours];
            updatedHours[index] = newItem;
            return updatedHours;
        });
    };
     
    useEffect(() => {
        setWorkingHours(initialWorkingHours);
    }, []);
    
    return (
        <div className={`${Style.mainWrapper} font-family-imp`}>
            <p className={Style.infoLabel}>Working hours</p>
            <div className={Style.mainContainer}>
                <p className={Style.label}>Set your weekly hours</p>
                <div className={Style.formWrapper}>
                    {workingHours.map((item, index) => 
                        <WorkingHoursItem key={index} index={index} item={item} handleItemChange={handleItemChange} />
                    )}
                </div>
                <div className={Style.btnWrapper}>
                    <Button btnClass="d_btn d_btn_primarySm font-family-imp" cssClass={Style.btnSave} label="Save" clickHandler={handleSave} showLoading={loading} />
                </div>
            </div>
        </div>
    );
}

export default WorkingHours;